<div class="dialogContainer" [ngClass]="{ 'visible' : showModal }">
  <div class="dialog">
    <div class="grid-container">
      <div class="grid-x"  [formGroup]="form" role="form">
        <div class="cell large-9 medium-9 small-9 bold text-align-left">
          <h3>Edit Contact</h3>
        </div>
        <div class="cell large-3 medium-3 small-3">
          <span class="minor-margin-right">
            <button class="button" (click)="save()" [disabled]="disableSave">Save</button>
          </span>
          <span>
            <button class="button" (click)="close()">Close</button>
          </span>
        </div>
        <div class="cell large-8 medium-8 small-8">
          <label class="display-inline-block"><span class="bold">Contact Name: </span>{{contactName}}</label>
        </div>
        <div class="cell large-4 medium-4 small-4">
          <div class="checkbox">
            <input class="show-for-sr no-margin vertical-align-middle" type="checkbox" id="canLogin" disabled [checked]="selectedContact?.canLogIn && selectedContact?.isUser" />
            <label for="canLogin" class="minor-margin-right display-inline-block">
              <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>   Contact Can Login
            </label>
          </div>
        </div>
        <div class="cell large-4 medium-4 small-4 text-align-right padding-right">
          <label for="primaryPhone">Primary Phone Number:</label>
        </div>
        <div class="cell large-4 medium-4 small-4">
          <input id="primaryPhone" type="text" formControlName="primaryPhone" />
        </div>
        <div class="cell large-4 medium-4 small-4">&nbsp;</div>
        <div class="cell large-4 medium-4 small-4 text-align-right padding-right">
          <label for="secondaryPhone">Secondary Phone Number:</label>
        </div>
        <div class="cell large-4 medium-4 small-4">
          <input id="secondaryPhone" type="text" formControlName="secondaryPhone" />
        </div>
        <div class="cell large-4 medium-4 small-4">&nbsp;</div>
        <div class="cell large-4 medium-4 small-4 text-align-right padding-right">
          <label for="email">Email Address:</label>
        </div>
        <div class="cell large-4 medium-4 small-4">
          <input id="email" type="text" formControlName="email" />
        </div>
        <div class="cell large-4 medium-4 small-4">&nbsp;</div>
        @if (selectedContact?.canLogIn  && selectedContact?.isUser) {
          <div class="cell large-12 medium-12 small-12 red bold">
            Use caution when altering the e-mail address of a user who is login enabled.  Changing their e-mail address without updating their OHID records will cause them to be unable to authenticate to RICS.
          </div>
        }

      </div>

    </div>
  </div>
</div>
